import "@sakai-ui/sakai-permissions/sakai-permissions.js"
import "@sakai-ui/sakai-search/sakai-search.js";
import "@sakai-ui/sakai-calendar/sakai-calendar.js";
import "@sakai-ui/sakai-grades/sakai-grades.js";
import "get-browser-fingerprint";
import { init as initJumpToTop } from "@sakai-ui/sakai-jump-to-top/sakai-jump-to-top.js";
initJumpToTop();
